import axios from 'axios';
import { baseUrl } from '../utils/constants';

// eslint-disable-next-line import/prefer-default-export
export const getMarkets = async (page = 1, pageSize = 50) => axios.get(
  `${baseUrl()}r/markets/?page=${page}&pageSize=${pageSize}`, { withCredentials: true },
);

export const CALIFORNIA_MARKET_KEY = 'california';
export const FLORIDA_MARKET_KEY = 'florida';

export const CALIFORNIA_MARKET_ID = 1
export const FLORIDA_MARKET_ID = 2
export const NEW_YORK_MARKET_ID = 3
export const GEORGIA_MARKET_ID = 4